const ANT_KEY_PATTERN = /^sk-ant-[A-Za-z0-9_\-.]+$/;
const REGULAR_KEY_PATTERN = /^sk-[A-Za-z0-9_\-.]+$/;
const SK_ANT_KEY_PREFIX = 'sk-ant-';
const SK_KEY_PREFIX = 'sk-';

export const apiKeyValidator = (key: string): boolean => {
  if (!key.trim()) {
    return false;
  }

  if (key.startsWith(SK_ANT_KEY_PREFIX)) {
    return ANT_KEY_PATTERN.test(key);
  }

  if (key.startsWith(SK_KEY_PREFIX)) {
    return REGULAR_KEY_PATTERN.test(key);
  }

  return false;
};
